module.exports = __webpack_public_path__ + "static/media/bw-social-tw.e65e6c4b.svg";